import './App.css';
import './css/Common.css'
import { Router, Switch, Route, Redirect } from 'react-router-dom';
import history from '../src/Components/history';
import { isTokenValid } from './utils/checkSessionStatus';
import LoginPage from './screens/Login';
import Admin from './screens/Admin';
import Budget from './screens/Budget';
import Report from './screens/Report';
import SignInProfile from './screens/SignInProfile';
import SigninSSO from './Components/login_components/SigninSSO';
import { Logout } from './auth/logout';
import LogoutCallback from './auth/logoutCallback';
import { SilentRenew } from './auth/silentRenew';
import {AuthProvider} from './utils/authProvider';

function App() {

  const ProtectedRoute = ({ component: Component, ...rest }) => (
    <Route
      {...rest}
      render={(props) =>
        isTokenValid() ? <Component {...props} /> : <Redirect to="/login" />
      }
    />
  );

  return (
    <AuthProvider>
    <Router history={history}>
      <Switch>
        <Route exact path="/">
          {isTokenValid() ? <Redirect to="/budget" /> : <Redirect to="/login" /> }
        </Route>
        <Route path="/login">
           { isTokenValid() ? <Redirect to="/budget" /> : <LoginPage /> }
        </Route>
        <ProtectedRoute path="/admin" component={Admin} />
        <ProtectedRoute path="/budget" component={Budget} />
        <ProtectedRoute path="/report" component={Report} />
        <ProtectedRoute path="/signinprofile" component={SignInProfile} />
        <Route exact path="/callback" component={SigninSSO} />
        <Route exact path="/logout" component={Logout} />
        <Route exact path="/logout/callback" component={LogoutCallback} />
        <Route exact path="/silentrenew" component={SilentRenew} />
      </Switch>
    </Router>
    </AuthProvider>
  );
}

export default App;
